var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 44,
    viewBox: "0 0 34 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.495 43.1199H0.495C0.221375 43.1199 0 42.8985 0 42.6249V1.37488C0 1.10126 0.221375 0.879883 0.495 0.879883H25.245C25.377 0.879883 25.5035 0.932133 25.5956 1.02426L33.8456 9.27426C33.9378 9.36776 33.99 9.49289 33.99 9.62489V42.6249C33.99 42.8985 33.7686 43.1199 33.495 43.1199ZM0.99 42.1299H33V10.1199H25.245C24.9714 10.1199 24.75 9.89851 24.75 9.62489V1.86988H0.99V42.1299ZM25.74 9.12988H32.3001L25.74 2.56976V9.12988ZM27.995 37.6199H5.995V36.6299H27.995V37.6199ZM27.995 32.1199H5.995V31.1299H27.995V32.1199ZM27.995 26.6199H5.995V25.6299H27.995V26.6199ZM27.995 21.1199H5.995V20.1299H27.995V21.1199ZM27.995 15.6199H5.995V14.6299H27.995V15.6199Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.75676680c83a688a6976cfece9d00079.svg";
export { ForwardRef as ReactComponent };